import React from "react";
import { Link, Outlet } from "react-router-dom";
import Login from "../../component/SignUp";
import Sidebar from "./component/Sidebar";
import WallPoster from "../../assets/WallPoster.png";

const MyAccount = () => {
  const isLoggedIn = true;
  const userData = {
    firstName: "Maria",
    lastName: "S",
  };

  return (
    <div>
      {isLoggedIn ? (
        <>
          {/* Breadcrumb */}
          <div
            className="bg-transparent px-4 sm:px-6 py-3 sticky top-[70px] z-10"
            style={{
              backgroundImage: `url(${WallPoster})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="max-w-[85rem] mx-auto">
              <div className="flex items-center gap-2 text-sm">
                <Link to="/" className="text-gray-500 hover:text-gray-700">
                  Home
                </Link>
                <span className="text-gray-500">/</span>
                <span className="text-gray-900">My Account</span>
              </div>
            </div>
          </div>

          {/* Welcome Banner */}
          <div
            className="bg-transparent px-4 sm:px-6 sticky top-[110px] z-10"
            style={{
              backgroundImage: `url(${WallPoster})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="max-w-[85rem] mx-auto py-2 sm:py-3 pb-6 sm:pb-11">
              <div className="flex justify-end">
                <span className="text-sm">
                  Welcome,{" "}
                  <span className="text-purple-600 font-medium">
                    {userData.firstName} {userData.lastName}
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="max-w-[85rem] mx-auto px-4 sm:px-6 min-h-screen">
            <div className="flex flex-col md:flex-row md:gap-8">
              {/* Sidebar is self-contained and handles its own responsive states */}
              <Sidebar />
              
              {/* Main content area */}
              <div className="flex-1 pt-8 sm:pt-0 pb-16">
                <Outlet />
              </div>
            </div>
          </div>
        </>
      ) : (
        <Login />
      )}
    </div>
  );
};

export default MyAccount;